import * as React from 'react';
import { Dispatch } from 'react-redux';
import { I18n } from 'react-redux-i18n';

import Popup, { FooterData } from '../Popup';
import Select from '../Form/Select';
import { Wrapper, Message, UserName, UserEmail } from './styles';
import { StoreState } from '../../reducers';
import { shareWithUser, reset, selectUser } from '../../containers/ShareWithUserPopup/actions';
import { Api } from '../../typings/api';

interface ShareWithUserPopupProps {
	isDisplayed: boolean;
	isLoading: boolean;
	users: Api.ShareUser[];
	selectedUserId: number | null;
	dispatch: Dispatch<StoreState>;
}

const ShareWithUserPopup = ({
	isDisplayed,
	isLoading,
	users,
	selectedUserId,
	dispatch,
}: ShareWithUserPopupProps) => {
	const isNoUsers = !isLoading && users.length === 0;
	const popupFooter: FooterData | undefined = isNoUsers
		? undefined
		: (
			{
				label: I18n.t('messages.invite_coworker'),
				onAccept: () => dispatch(shareWithUser()),
			}
		);

	const handleChange = ({ value }) => {
		dispatch(selectUser(value));
	};

	const usersOptions = users.map(({ id, name, email }) => ({
		value: id,
		label: (
			<div>
				<UserName>{name}</UserName>
				<UserEmail>{email}</UserEmail>
			</div>
		),
	}));

	return (
		<Popup
			isDisplayed={isDisplayed}
			isLoading={isLoading}
			label={I18n.t('messages.choose_coworker')}
			onCancel={() => dispatch(reset())}
			footer={popupFooter}
		>
			<Wrapper hasUsers={!isNoUsers}>
				{isNoUsers
					? <Message value="messages.no_share_users" />
					: (
						<Select
							value={selectedUserId as number}
							options={usersOptions}
							onChange={handleChange}
						/>
					)
				}
			</Wrapper>
		</Popup>
	);
};

export default ShareWithUserPopup;



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/components/ShareWithUserPopup/index.tsx